import { render, staticRenderFns } from "./engagementRingsRedgold.vue?vue&type=template&id=3bb2a847"
import script from "./engagementRingsRedgold.vue?vue&type=script&lang=ts"
export * from "./engagementRingsRedgold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MetaTitle: require('/codebuild/output/src1993466134/src/acredo-website/components/meta/MetaTitle.vue').default,CatalogHeader: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogHeader.vue').default,Catalog: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/Catalog.vue').default,CatalogFooter: require('/codebuild/output/src1993466134/src/acredo-website/components/catalog/CatalogFooter.vue').default,Breadcrumb: require('/codebuild/output/src1993466134/src/acredo-website/components/Breadcrumb.vue').default})
